module.exports = __webpack_public_path__ + "media/images/riders/small/BERNARD_KERR-bbb558837e5b11bcafceb539088d24cc.png";